import React from 'react';

import { useApiGet, useApiLoading } from 'react-reqq-lite';

import { getCategoryList } from '../actions';

export const useGetCategoryList = (filter) => {
  const isApiLoading = useApiLoading('COMMON/CATEGORY_LIST', 'get');
  const list = useApiGet('COMMON/CATEGORY_LIST', []);

  React.useEffect(() => {
    getCategoryList(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filter)]);

  return [isApiLoading, list];
};
